import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

// 開いているモーダルを閉じてから別のモーダルを開く。
//
// data-bs-toggle と data-bs-dismiss を同一要素に付けても bootstrap_data_api.js の
// クリック委譲は toggle を処理した時点で return するため dismiss が動かない。
// また hidden.bs.modal を待たずに次を開くと、閉じる側の後始末が backdrop と
// body.modal-open を落として次のモーダルが操作不能になる。
//
// サーバ側で開いた状態(.modal.show + 静的 .modal-backdrop)で描画されたモーダルは
// BS5 インスタンスを持たないため .hide() では静的 backdrop が残る。その場合は
// DOM を直接畳む(legacy/bootstrap-modal.js と同じ扱い)。
export default class extends Controller {
  static values = { modal: String };

  open(event) {
    event.preventDefault();

    const next = document.querySelector(this.modalValue);
    if (!next) return;

    const current = this.element.closest('.modal');
    if (!current) {
      Modal.getOrCreateInstance(next).show();
      return;
    }

    const instance = Modal.getInstance(current);
    if (!instance) {
      this._collapseStatic(current);
      Modal.getOrCreateInstance(next).show();
      return;
    }

    current.addEventListener(
      'hidden.bs.modal',
      () => Modal.getOrCreateInstance(next).show(),
      { once: true }
    );
    instance.hide();
  }

  _collapseStatic(modal) {
    modal.classList.remove('show');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
  }
}
